import { ReactElement } from 'react'

import Image from 'next/image'
import Link from 'next/link'

import dayjs from 'dayjs'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import { LEGAL_COMPANY } from '@/config/legal.constants'
import { useReachGoal } from '@/hooks/useReachGoal'

import logo from './icons/logo.svg'
import telegram from './icons/telegram.svg'
import text from './icons/text.svg'
import styles from './styles.module.scss'

const links = [
    { title: 'Как работает', hash: 'how-it-works' },
    { title: 'Задания', hash: 'tasks' },
    {
        title: 'Как подключиться',
        hash: 'how-to-connect',
    },
]

export default function Footer(): ReactElement {
    const reachGoal = useReachGoal()

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.top}>
                    <div>
                        <Link
                            href={SETTINGS_GENERAL.SITE_URL}
                            className={styles.logo}
                            onClick={() =>
                                reachGoal({
                                    goalName: 'went-to-the-main-site',
                                })
                            }
                        >
                            <Image
                                src={logo}
                                alt={'BukaGo'}
                                className={styles.logo__sign}
                            />
                            <div className={styles.logo__text}>
                                <Image
                                    src={text}
                                    alt={'BukaGo'}
                                    className={styles.logo__sub}
                                />
                                <div className={styles.logo__description}>
                                    {'Родительский контроль и геолокация'}
                                </div>
                            </div>
                        </Link>
                    </div>
                    <nav className={styles.nav}>
                        {links.map(link => (
                            <Link
                                key={link.hash}
                                href={`/#${link.hash}`}
                                onClick={() =>
                                    reachGoal({
                                        goalName: 'went-to-the-main-site',
                                    })
                                }
                            >
                                {link.title}
                            </Link>
                        ))}
                    </nav>
                </div>
                <div className={styles.bottom}>
                    <div className={styles.bottom__left}>
                        <div className={styles.social}>
                            <Link
                                href={SETTINGS_GENERAL.SOCIAL_TELEGRAM_LINK}
                                aria-label={'Telegram'}
                                target={'_blank'}
                                onClick={() =>
                                    reachGoal({
                                        type: 'params',
                                        goalName: 'click-social-network',
                                        params: {
                                            type: 'Telegram',
                                        },
                                    })
                                }
                            >
                                <Image src={telegram} alt={'Telegram'} />
                            </Link>
                        </div>
                    </div>
                    <div className={styles.bottom__center}>
                        <p className={styles.legal}>
                            {`© BukaGo, ${dayjs().format('YYYY')}. Все права защищены.`}
                        </p>
                        <p className={styles.legal}>{LEGAL_COMPANY.name}</p>
                    </div>
                    <div className={styles.bottom__right}>
                        <Link
                            href={SETTINGS_GENERAL.SITE_URL}
                            className={styles.button}
                            onClick={() =>
                                reachGoal({
                                    goalName: 'went-to-the-main-site',
                                })
                            }
                        >
                            {'Перейти на сайт BukaGo'}
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}
